/* istanbul ignore next (See: https://github.com/graphql/graphql-js/issues/2317) */
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol["for"] === 'function' ? Symbol["for"]('nodejs.util.inspect.custom') : undefined;
export default nodejsCustomInspectSymbol;